import { FormilyForm } from "../../../../../components/Formily";
import { Empty } from 'antd';
import { useMemo, useRef } from 'react';
import { compact } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
function jsonParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
export default function TDBasicInfo(props) {
  var _props$data = props.data,
    formSchema = _props$data.formSchema,
    formValue = _props$data.formValue,
    flowOrderId = _props$data.flowOrderId,
    taskOrderId = _props$data.taskOrderId;
  var key = compact([flowOrderId, taskOrderId]).join('-');
  var formRef = useRef(null);
  var schemaVal = useMemo(function () {
    return jsonParse(formSchema);
  }, [formSchema]);
  var formVal = useMemo(function () {
    return jsonParse(formValue);
  }, [formValue]);
  var showEmpty = useMemo(function () {
    return schemaVal == null;
  }, [schemaVal]);
  return /*#__PURE__*/_jsx("div", {
    children: showEmpty ? /*#__PURE__*/_jsx(Empty, {
      image: Empty.PRESENTED_IMAGE_SIMPLE
    }) : /*#__PURE__*/_jsx(FormilyForm, {
      schema: schemaVal,
      ref: formRef,
      options: {
        values: formVal,
        pattern: 'readOnly',
        effects: function effects(form) {
          // @ts-ignore
          window.form = form;
        }
      }
    }, key)
  });
}